import { Country, Location, State } from "store/types";

export type SjdBookingInlineData = {
  sjd_booking_dir_url: string;
  sjd_booking_visitor_ip: string;
} & Window &
  typeof globalThis;

export type InlineScriptVars = {
  terms_and_conditions: string;
  plugin_dir_url: string;
  stripe_pk: string;
  default_location: string;
};

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    h5md?: true;
    h1?: true;
    stepperTitle?: true;
    h2?: true;
    h3?: true;
    h4?: true;
    h5sb?: true;
    inputTitle?: true;
    fieldText?: true;
    secondaryText?: true;
    labelErrorText?: true;
    cardLabelText?: true;
    cardSeatsText?: true;
    cardTripTypeText?: true;
    cardFooter?: true;
    summaryEmptyDescription?: true;
  }
}

export type Car = {
  carName: string;
  price: number;
  vehicleId: string;
  numberOfSeats: number;
  picturePath: string;
  oneSeatAllowed: false;
  noMoreThenAmountOfPeople: number;
  isShuttle: boolean;
  description?: string;
  tripType?: string;
};

export type FormDataModel = {
  // fields
  // step 1
  customDestination: string;
  destination: boolean;
  destinationLocation: Location | null;
  isCustomDestination: boolean;
  pickupLocation: Location | null;
  roundTripReservation: boolean;
  // step 2
  numberOfPassengers: number;
  selectedCar: Car | null;
  // step 3
  bookingDate: Date | string;
  bookingTime: string;
  departureDate: Date | string;
  departureTime: string;
  bookingDetailsNotes: string;
  signName: string;
  departureFlightNumber: string;
  arrivalFlightNumber: string;
  departureAirline: string;
  arrivalAirline: string;
  // step 4
  ArrivalAddon:
    | {
        addon_id: string;
        count: number;
      }[]
    | null;
  DepartureAddon:
    | {
        addon_id: string;
        count: number;
      }[]
    | null;
  addons: AddonsFormObject | null;
  // step 5
  state: State | null;
  country: Country | null;
  additionalPhone: string;
  address: string;
  address2: string;
  city: string;
  confirmEmailAddress: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  mobilePhone: string;
  postalCode: string;
  // step 6
  couponCode: string;
  paymentVariant: "stripe";
  termsAndCondition: boolean;
  //
  locationIsAirport: boolean;
  destinationIsAirport: boolean;
};

export const formDataInitial: FormDataModel = {
  // fields
  customDestination: "",
  destination: false,
  destinationLocation: null,
  isCustomDestination: false,
  pickupLocation: null,
  roundTripReservation: false,
  // step 2
  selectedCar: {
    carName: "",
    price: 0,
    vehicleId: "",
    numberOfSeats: 0,
    picturePath: "",
    oneSeatAllowed: false,
    noMoreThenAmountOfPeople: 0,
    isShuttle: false,
  },
  numberOfPassengers: 1,
  // step 3
  bookingDate: "",
  bookingTime: "",
  departureDate: "",
  departureTime: "",
  bookingDetailsNotes: "",
  signName: "",
  departureFlightNumber: "",
  arrivalFlightNumber: "",
  departureAirline: "",
  arrivalAirline: "",
  // step 4
  ArrivalAddon: null,
  DepartureAddon: null,
  addons: null,
  // step 5
  state: null,
  country: null,
  additionalPhone: "",
  address: "",
  address2: "",
  city: "",
  confirmEmailAddress: "",
  emailAddress: "",
  firstName: "",
  lastName: "",
  mobilePhone: "",
  postalCode: "",
  // step 6
  couponCode: "",
  paymentVariant: "stripe",
  termsAndCondition: false,
  //
  locationIsAirport: false,
  destinationIsAirport: false,
};

export type AddonCardData = {
  description: string;
  name: string;
  price: number;
  src: string;
  addon_id: string;
  round_trip_price?: number;
};

export type LocationTypeName = "arrival" | "departure";

export type AddonsFormData = {
  addon_id: string;
  count: number;
  name?: string;
  price: number;
  type?: LocationTypeName;
};
export type AddonsFormObject = {
  [key in LocationTypeName]: AddonsFormData[];
};
